import './templates';
import './template-kit';

import { registerStore } from '@wordpress/data';

const DEFAULT_STATE = () => {
	const initState = {
		customStyles: '',
		customStylesData: {},
	};

	return initState;
};

const actions = {
	updateCustomStyles( data ) {
		return {
			type: 'UPDATE_CUSTOM_STYLES',
			data,
		};
	},
	updateCustomStylesData( data ) {
		return {
			type: 'UPDATE_CUSTOM_STYLES_DATA',
			data,
		};
	},
};

registerStore( 'Gutenify/store', {
	reducer( state = DEFAULT_STATE(), action ) {
		switch ( action.type ) {
			case 'UPDATE_CUSTOM_STYLES':
				return { ...state, customStyles: action.data };
			case 'UPDATE_CUSTOM_STYLES_DATA':
				return { ...state, customStylesData: { ...state.customStylesData, ...action.data } };
		}

		return state;
	},

	actions,

	selectors: {
		getAllStore( store ) {
			return { ...store };
		},
		getCustomStyles( state ) {
			return state.customStyles;
		},
		getCustomStylesData( state ) {
			return state.customStylesData;
		},
	},
	resolvers: {
		// * getCustomStylesData() {
		// 	const { getEditedPostAttribute } = select( 'core/editor' );
		// 	let customCssData = getEditedPostAttribute( 'meta' ).gutenify_custom_css_data;
		// 	customCssData = '' !== customCssData ? JSON.parse( customCssData ) : {};
		// 	return actions.updateCustomStylesData( customCssData );
		// },
	},
} );
